import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/search/empty-professionals.webp")